export default __webpack_public_path__ + "static/media/3.2fa9ec91.png";